import Cookies from 'js-cookie';
import { useContext, useEffect, useState } from 'react';
import constants from '../../../constants/constants';
import { Button, Card, Input, Table, Tooltip } from 'antd';
import APIUtils from '../../../api/APIUtils';
import WebLinks from '../../../api/WebLinks';
import * as XLSX from "xlsx";
import { FileExcelOutlined } from "@ant-design/icons";
import { CommonContext } from '../../../Context';
const { Search } = Input;
const Market = () => {
  const commonContext=useContext(CommonContext);
  const buyerId = commonContext.common.buyerId;
  const [searchText, setSearchText] = useState("");
  const [cpaData, setCpaData] = useState([]);
  const [hireData, setHireData] = useState([]);
  const [cpaLoading, setCpaLoading] = useState(false);
  const [hireLoading, setHireLoading] = useState(false);
  const [cpaPagination, setCpaPagination] = useState({
    current: 1,
    pageSize: 10,
  });
  const [hirePagination, setHirePagination] = useState({
    current: 1,
    pageSize: 10,
  });
  const fetchCPA = async () => {
    try {
      setCpaLoading(true);
      const res = await APIUtils.apiCall(
        "GET",
        `${WebLinks.GetMarketData}?buyerId=${buyerId}`
      );
      if (!res.isCatch && res.resultObj.statusCode === "2000") {
        setCpaData(res.resultObj.data || []);
      } else {
        setCpaData([]);
      }
    } catch {
      setCpaData([]);
    } finally {
      setCpaLoading(false);
    }
  };

  const fetchInterviewHire = async () => {
    try {
      setHireLoading(true);
      const res = await APIUtils.apiCall(
        "GET",
        `${WebLinks.GetMarketDataOccupationInterview}?buyerId=${buyerId}`
      );
      if (!res.isCatch && res.resultObj.statusCode === "2000") {
        setHireData(res.resultObj.data || []);
      } else {
        setHireData([]);
      }
    } catch {
      setHireData([]);
    } finally {
      setHireLoading(false);
    }
  };

  useEffect(() => {
    if (!buyerId) return;
    fetchCPA();
    fetchInterviewHire();
  }, [buyerId]);

  const downloadTable = (data, fileName) => {
    let excelData = [];
    switch(fileName){
      case constants.AverageCPAByOccupation:
        excelData = data.map(item => ({
          "Occupation": item.occupation,
          "Average CPA": item.averageCPA ? Number(item.averageCPA).toFixed(2) :0,
        }));
      break;
      case constants.AverageCPIByOccupation:
        excelData = data.map(item => ({
          "Occupation": item.occupation,
          "Cost Per Interview": item.costPerInterview ? Number(item.costPerInterview).toFixed(2) : 0,
          "Cost Per Hire": item.costPerHire ? Number(item.costPerHire).toFixed(2) : 0,
        }));
        break;
    }
    const ws = XLSX.utils.json_to_sheet(excelData);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Data");
    XLSX.writeFile(wb, `${fileName}.xlsx`);
  };

  const filterData = (data) =>
    data.filter((item) =>
      Object.values(item)
        .join(" ")
        .toLowerCase()
        .includes(searchText.toLowerCase())
    );

  const cpaColumns = [
    {
      title: "Occupation",
      dataIndex: "occupation",
      sorter: (a, b) =>
        (a.occupation || "").localeCompare(b.occupation || ""),
      sortDirections: ["ascend", "descend"],
    },
    {
      title: "Average CPA",
      dataIndex: "averageCPA",
      align: "right",
      render: (val) => Number(val || 0).toFixed(2),
      sorter: (a, b) => (a.averageCPA || 0) - (b.averageCPA || 0),
      sortDirections: ["ascend", "descend"],
    },
  ];

  const interviewHireColumns = [
    {
      title: "Occupation",
      dataIndex: "occupation",
      sorter: (a, b) =>
        (a.occupation || "").localeCompare(b.occupation || ""),
      sortDirections: ["ascend", "descend"],
    },
    {
      title: "Cost Per Interview",
      align: "right",
      dataIndex: "costPerInterview",
      render: (val) => val ? Number(val).toFixed(2) : 0,
      sorter: (a, b) => (a.costPerInterview || 0) - (b.costPerInterview || 0),
      sortDirections: ["ascend", "descend"],
    },
    {
      title: "Cost Per Hire",
      dataIndex: "costPerHire",
      align: "right",
      render: (val) => val ? Number(val).toFixed(2) : 0,
      sorter: (a, b) => (a.costPerHire || 0) - (b.costPerHire || 0),
      sortDirections: ["ascend", "descend"],
    },
  ];
  const downloadButton = (data, type) => (
    <Tooltip title="Download as Excel">
      <Button
        icon={<FileExcelOutlined />}
        className='bg-green-800 text-white hover:!text-white hover:!border-green-500'
        onClick={() => downloadTable(data, type)}
      />
    </Tooltip>
  )
  return (
    <div>
      <div className="flex mb-4 w-[90%]">
        <Search
          placeholder="Search"
          allowClear
          value={searchText}
          onChange={(e) => setSearchText(e.target.value)}
          className="w-64"
        />
      </div>
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 mx-auto">
        <Card
          title={constants.AverageCPAByOccupation}
          extra={downloadButton(cpaData, constants.AverageCPAByOccupation)}
          className="shadow rounded"
        >
          <Table
            columns={cpaColumns}
            dataSource={filterData(cpaData)}
            className='custom-table'
            rowKey="occupation"
            scroll={{ x: "max-content" }}
            loading={cpaLoading}
            pagination={{
              ...cpaPagination,
              showSizeChanger: true,
              pageSizeOptions: ['10', '20', '50', '100'],
              showTotal: (total, range) =>
                `${range[0]}-${range[1]} of ${total} records`,
              onChange: (page, pageSize) => {
                setCpaPagination({
                  current: page,
                  pageSize,
                });
              },
            }}
          />
        </Card>
        <Card
          title={constants.AverageCPIByOccupation}
          extra={downloadButton(hireData, constants.AverageCPIByOccupation)}
          className="shadow rounded"
        >
          <Table
            columns={interviewHireColumns}
            dataSource={filterData(hireData)}
            className='custom-table'
            rowKey="occupation"
            scroll={{ x: "max-content" }}
            loading={hireLoading}
            pagination={{
              ...hirePagination,
              showSizeChanger: true,
              pageSizeOptions: ['10', '20', '50', '100'],
              showTotal: (total, range) =>
                `${range[0]}-${range[1]} of ${total} records`,
              onChange: (page, pageSize) => {
                setHirePagination({
                  current: page,
                  pageSize,
                });
              },
            }}
          />
        </Card>
      </div>
    </div>
  );
};
export default Market;
